import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader, getLocalStorageItem,
    getPathBack,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import Container from "react-bootstrap/Container"
import {LoaderClass} from "../elements/LoaderClass"
import {PathLineClass} from "../elements/PathLineClass"
import {ViewWindowQuestion} from "../elements/ViewWindowQuestion"
import {useNavigate} from "react-router-dom"

export const CreateNotePage = ({newNoteObject = null}) => {
    setLocalStorageItem('page', 'CreateNotePage')
    const $ = require("jquery")

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const urlParams = new URLSearchParams(window.location.search)
    const folderId = urlParams.get('folderId')
    let lang = objectLang().language
    const l = lang.lang
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [isQuestion, setIsQuestion] = useState(true)
    const navigate = useNavigate()

    const saveNewNoteHandler = async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        if (!$('#name').val()) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/create-note?folderId=${folderId}`
            ))
            return
        }
        try {
            const data = await request(
                `${host}/api/note/create`,
                'POST',
                {
                    userId: auth.userId,
                    parentFolder: folderId,
                    name: document.querySelector('#name').value,
                    body: document.querySelector('#body-note').value
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(folderId)
                window.location.replace(`/${l}/note/open/${data.note._id}`)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const availableScreenHeight = Math.trunc(window.screen.availHeight * 0.5)
    const styleTextarea = {
        height: availableScreenHeight,
        background: "beige"
    }

    const closeNoteHandler = (newNote) => {
        setLocalStorageItem('note-new-create', newNote)
        if (!newNote.name && !newNote.body) {
            navigate(getPathBack(), {replace: true})
        } else if (!newNote.name && newNote.body) {
            setIsQuestion(false)
            setDataModal(setErrorWindow(
                lang.body.notePage.windowRequestIfSave.titleCreate,
                '',
                lang.body.notePage.windowRequestIfSave.descriptionCreate,
                lang.body.notePage.windowRequestIfSave.btnOKTapeName,
                'tapeNoteName',
                lang.body.notePage.windowRequestIfSave.btnCancelCreate,
                'replaceToBack',
                'success',
                'danger'))
        } else if ((newNote.name && newNote.body) || (newNote.name && !newNote.body)) {
            setIsQuestion(false)
            setDataModal(
                setErrorWindow(
                    lang.body.notePage.windowRequestIfSave.titleCreate,
                    '',
                    lang.body.notePage.windowRequestIfSave.descriptionCreate,
                    lang.body.notePage.windowRequestIfSave.btnOKCreate,
                    'saveNewNote',
                    lang.body.notePage.windowRequestIfSave.btnCancelCreate,
                    'replaceToBack',
                    'success',
                    'danger'))
        } else {
            navigate(getPathBack(), {replace: true})
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                {<CreateNotePage newNoteObject={getLocalStorageItem('note-new-create')}/>}
                {<ModalWin data={dataModal}/>}
            </>

        )
    }

    if (!isQuestion) {
        const newNoteObj = {
            userId: auth.userId,
            parentFolder: folderId,
            name: document.querySelector('#name').value,
            body: document.querySelector('#body-note').value
        }
        return (
            <>
                {<CreateNotePage newNoteObject={getLocalStorageItem('note-new-create')}/>}
                {<ViewWindowQuestion object={newNoteObj} data={dataModal}/>}
            </>
        )
    }

    return (
        <>
            <PathLineClass documents={getLocalStorageItem('documents')}/>
            <Container className={"mt-3 mt-lg-5 text-center"}>
                <div className={"d-flex flex-wrap justify-content-center card mb-3"}>
                    <div className={"card-header card-note text-success d-flex justify-content-start"}>
                        <div className={"d-flex flex-nowrap align-items-center w-100"}>

                            <div className="flex-grow-1 pe-3" style={{minWidth: 0}}>
                                {!newNoteObject && <input
                                    placeholder={lang.body.createNotePage.placeholderName}
                                    type={"text"}
                                    className={"form-control fs-2 text-primary text-center"}
                                    id={"name"}
                                    style={{background: "beige"}}
                                />}
                                {newNoteObject && <input
                                    placeholder={lang.body.createNotePage.placeholderName}
                                    type={"text"}
                                    className={"form-control fs-2 text-primary text-center"}
                                    id={"name"}
                                    style={{background: "beige"}}
                                    defaultValue={newNoteObject.name}
                                />}
                            </div>

                            <button
                                id="button-save-note"
                                className="btn btn-save text-success flex-shrink-0"
                                type="button"
                                aria-label="Save"
                                disabled={!auth.isAuthenticated}
                                onClick={saveNewNoteHandler}
                            >
                                <i className="fa-solid fa-floppy-disk fs-1"/>
                            </button>

                            <button
                                id="button-close-note"
                                type="button"
                                className="btn-close flex-shrink-0 fs-2 ms-lg-3"
                                aria-label="Close"
                                onClick={() => {
                                    const newNoteObj = {
                                        userId: auth.userId,
                                        parentFolder: folderId,
                                        name: document.querySelector('#name').value,
                                        body: document.querySelector('#body-note').value
                                    }
                                    closeNoteHandler(newNoteObj)
                                }}
                            />
                        </div>

                    </div>
                    <div className={"card-body card-note"}>
                        {!newNoteObject && <textarea
                            placeholder={lang.body.createNotePage.placeholderText}
                            className={"form-control fs-4 text-success"}
                            id={"body-note"}
                            style={styleTextarea}
                        />}
                        {newNoteObject && <textarea
                            placeholder={lang.body.createNotePage.placeholderText}
                            className={"form-control fs-4 text-success"}
                            id={"body-note"}
                            style={styleTextarea}
                            defaultValue={newNoteObject.body}
                        />}
                    </div>
                </div>
            </Container>
        </>
    )
}
